@if (header) {
  <div class="nav-tab-header">{{ header }}</div>
}
<ul class="nav nav--underline">
  @for (tab of tabItems.toArray(); track tab; let i = $index) {
    <li class="nav-item">
      <a class="nav--link" [class.active]="i === activeTabIndex" [class.nav-snow-white]="whiteTabColor" aria-current="page" (click)="selectTab(i)">{{
        tab.title }}</a>
    </li>
  }
</ul>

@for (tab of tabItems.toArray(); track tab; let i = $index) {
  @if (i === activeTabIndex) {
    <ng-template [ngTemplateOutlet]="tab._content"></ng-template>
  }
}